module.exports = __webpack_public_path__ + "img/banner2_7.ab749795.jpg";